<!-- //
数据源列表
@auth xuyd
@date 2024-05-01
//-->
<template>
  <page-layout layout="C">
    <div class="layout-search" style="display: flex; flex-direction: row; justify-content: space-between">
      <el-form @submit.native.prevent ref="refForm" :model="queryParams" size="small" :inline="true" label-width="100px">
        <el-form-item prop="dsName">
          <el-input
              v-model="queryParams.dsName"
              placeholder="请输入数据源名称"
              style="width: 300px;"
              maxlength="20"
              clearable
              @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="handleQuery" icon="el-icon-search">检索</el-button>
          <el-button type="primary" size="small" plain @click="handleReset" icon="el-icon-refresh">重置</el-button>
        </el-form-item>
      </el-form>
      <div style="display:flex; justify-content: right;">
          <el-button type="primary" size="small" @click="handleAdd" icon="el-icon-plus">添加数据源</el-button>
      </div>
    </div>
    <!-- 结果区域 -->
    <div class="layout-result" style="height: calc(100% - 63px);">
      <el-table ref="refTable" v-loading="tableLoading" :data="list"
                border
                stripe
                height="100%"
                size="small"
                :header-cell-style="this.tableHeader">
        <el-table-column header-align="center" align="center" label="No." width="60" type="index"/>
        <el-table-column header-align="left" align="left" label="数据源名称" min-width="120" prop="dsName"/>
        <el-table-column header-align="left" align="left" label="数据库类型" width="100" prop="dbType"/>
        <el-table-column header-align="left" align="left" label="地址" min-width="100" prop="hostName"/>
        <el-table-column header-align="left" align="left" label="端口" width="60" prop="port"/>
        <el-table-column header-align="left" align="left" label="连接参数" min-width="250" prop="properties"/>
        <el-table-column header-align="left" align="left" label="数据库名" width="110" prop="dbName"/>
        <el-table-column header-align="left" align="left" label="账号" width="90" prop="username"/>
        <el-table-column header-align="left" align="left" label="密码" width="100" prop="pwd"/>
        <el-table-column header-align="left" align="left" label="" width="120" prop="maxWaitTime">
          <template #header>
            <span>连接等待时间(S)</span>
          </template>
        </el-table-column>
        <el-table-column header-align="left" align="left" label="最大连接数" width="90" prop="maxActive"/>
        <el-table-column header-align="left" align="left" label="查询超时(S)" width="90" prop="queryTimeout"/>
        <el-table-column header-align="left" align="left" label="有效状态" width="70" prop="status">
          <template slot-scope="{row}">
            <dict-tag :options="{type: 'tag'}" dictType="YES_OR_NO" :value="row.status"/>
          </template>
        </el-table-column>
        <el-table-column header-align="left" label="操作" align="left" width="160" fixed="right">
          <template slot-scope="{row}">
            <el-button size="small" type="text" @click="handleTest(row)" :loading="row.loading">测试</el-button>
            <el-button size="small" type="text" @click="handleEdit(row)">编辑</el-button>
            <el-button size="small" type="text" @click="handleCopy(row)">复制</el-button>
            <el-button size="small" type="text" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination :total="total" :pageNum.sync="queryParams.pageNum" :pageSize.sync="queryParams.pageSize"
                  @pagination="getList"/>
    </div>
    <AddDlg ref="refAddDlg"/>
  </page-layout>
</template>

<script>
import DatasourceApi from '@/api/datasvc/datasource.api.js';
import AddDlg from './add';

export default {
  name: 'ViewDatabaseList',
  components: {AddDlg},
  dictTypes: [
    {dictType: 'YES_OR_NO', dataType: Number},
    {dictType: 'DB_TYPE', dataType: String},
  ],
  data() {
    return {
      list: [],
      total: 0,
      tableLoading: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        dsName: null,
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      DatasourceApi.searchList(this.queryParams).then(resp => {
        this.list = resp.data.records.map(item => {
          item.loading = false;
          return item;
        });
        this.total = resp.data.total;
      })
    },
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },

    handleReset() {
      this.resetForm('refForm');
      this.handleQuery();
    },

    /**
     * 新增
     */
    handleAdd() {
      this.$refs.refAddDlg.showModal({
        data: {},
        mode: 1,
        title: '添加数据源',
        onOk: (data) => {
          this.getList();
        }
      });
    },

    /**
     * 编辑
     */
    handleEdit(row) {
      this.$refs.refAddDlg.showModal({
        data: {...row},
        mode: 2,
        title: '编辑数据源',
        onOk: (data) => {
          this.getList();
        }
      });
    },

    /**
     * 编辑
     */
    handleCopy(row) {
      let data = {...row};
      data.id = null;
      this.$refs.refAddDlg.showModal({
        data: data,
        mode: 1,
        title: '复制数据源',
        onOk: (data) => {
          this.getList();
        }
      });
    },

    /**
     * 删除
     * @param row
     */
    handleDelete(row) {
      this.$modal.confirm(`确定要删除【${row.dsName}】吗？`).then(() => {
        DatasourceApi.deleteInfo(row.id).then(resp => {
          this.$modal.msgSuccess('删除成功');
          this.getList();
        })
      })
    },

    /**
     * 测试
     * @param row
     */
    handleTest(row) {
      row.loading = true;
      DatasourceApi.testConn(row.id).then(resp => {
        row.loading = false;
        if (resp.data) {
          this.$modal.msgSuccess('连接成功');
        } else {
          this.$modal.msgError('连接失败');
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
</style>
